export default function NotFound() {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-20">
        <h1 className="text-5xl md:text-40xl font-semibold text-red-300">404</h1>
        
      </div>
    );
  }